import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'User',
    field: 'userId',
    // section: 'Data Relations',
    // description: 'Listing of all users who have access to modify this school'
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'userId',
      fk: 'id',
      namespace: 'aspnetuser',
      filterIs: 'text-filter',
      label: 'username'
    })
  }),
  createColumn({
    label: 'Role',
    field: 'role',
    // section: 'Data Relations',
    // description: 'Listing of all users who have access to modify this school'
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'roleId',
      fk: 'id',
      namespace: 'userRoles',
      filterIs: 'text-filter',
      label: 'id'
    })
  })
].concat(defaultColumns)
